import { ExclamationIcon } from "@heroicons/react/outline";
import { ReactNode } from "react";

const AppError = ({
  className,
  children,
}: {
  className?: string;
  children?: ReactNode;
}) => {
  return (
    <div className={`AppSpinner AppError ${className}`}>
      <ExclamationIcon
        className="AppSpinner-icon"
        color="darkred"
        height="44px"
        aria-hidden={true}
      />
      {children}
      <h6 style={{ marginTop: "1em", fontStyle: "normal" }}>
        Please check your Internet connection
        <br />
        and try refreshing the page
      </h6>
      <h6 style={{ marginTop: "1em", fontStyle: "normal" }}>
        If you continue to see this message
        <br />
        contact{" "}
        <a href="mailto: support@pathologywatch.com">
          support@pathologywatch.com
        </a>
      </h6>
    </div>
  );
};

export default AppError;
